import router from "../../routes";

const state = () => ({
    crumbs: []
})

const getters = {
    GET_CRUMBS: (state) => {
        return state.crumbs
    }
}

const actions = {
    SET_FOR_GROUP: ({commit}, data) => {
        commit("INIT_CRUMBS")
        commit("SET_FOR_GROUP", data)
    },

    SET_FOR_PRODUCT: ({commit}, data) => {
        commit("INIT_CRUMBS")
        commit("SET_FOR_PRODUCT", data)
    },
}
const mutations = {
    INIT_CRUMBS: (state) => {
        state.crumbs = []
        state.crumbs.push({
            'href': router.resolve({name: 'catalog'}).fullPath,
            'name': router.resolve({name: 'catalog'}).meta.name
        })
    },

    SET_FOR_GROUP: (state, {name, parent}) => {

        if (Object.keys(parent).length != 0) {
            state.crumbs.push({
                name: parent.name,
                href: router.resolve({name: 'group', params: {group_slug: parent.slug.split('_').join('-')}}),
            })
        }

        state.crumbs.push({
            name,
            href: "",
        })
    },

    SET_FOR_PRODUCT: (state, {name, parent}) => {

        if (Object.keys(parent).length != 0) {
            state.crumbs.push({
                name: parent.name,
                href: router.resolve({name: 'group', params: {group_slug: parent.slug.split('_').join('-')}}),
            })
        }

        state.crumbs.push({
            name,
            href: "",
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
